'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var TextField = require('@material-ui/core/TextField');
require('../GoogleMapsProvider/GoogleMapsProvider.js');
var useGeocoder = require('../GoogleMapsProvider/useGeocoder.js');
require('../node_modules/ngeohash/main.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);

var _excluded = ["disableGeocode", "value", "onInputChange", "onGeocode", "onGeocoderError", "onGeocoderSuccess", "onGeocoderSettled", "componentsMap"];
var AddressField = _ref => {
  var {
    disableGeocode = false,
    value,
    onInputChange,
    onGeocode,
    onGeocoderError,
    onGeocoderSuccess,
    onGeocoderSettled,
    componentsMap
  } = _ref,
      textFieldProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var {
    geocode
  } = useGeocoder.useGeocoder();

  function handleBlur(_x) {
    return _handleBlur.apply(this, arguments);
  }

  function _handleBlur() {
    _handleBlur = _rollupPluginBabelHelpers.asyncToGenerator(function* (event) {
      // Trigger any events passed to the text field.
      textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.onBlur(event);

      if (disableGeocode) {
        return;
      }

      var geocoderRequest = {
        address: value
      };

      try {
        onGeocode === null || onGeocode === void 0 ? void 0 : onGeocode();
        var results = yield geocode(geocoderRequest, componentsMap);
        onGeocoderSuccess === null || onGeocoderSuccess === void 0 ? void 0 : onGeocoderSuccess(results);
      } catch (error) {
        onGeocoderError === null || onGeocoderError === void 0 ? void 0 : onGeocoderError(error);
      } finally {
        onGeocoderSettled === null || onGeocoderSettled === void 0 ? void 0 : onGeocoderSettled();
      }
    });
    return _handleBlur.apply(this, arguments);
  }

  return /*#__PURE__*/React__namespace.createElement(TextField__default['default'], _rollupPluginBabelHelpers['extends']({}, textFieldProps, {
    value: value,
    onChange: onInputChange,
    multiline: true,
    minRows: 3,
    maxRows: 7,
    onBlur: handleBlur
  }));
};
AddressField.propTypes = {
  /**
   * If `true`, the field will not query Google Maps for the address components.
   */
  disableGeocode: index.bool,

  /**
   * The formatted string value of the address.
   */
  value: index.string,

  /**
   * Callback fired when the formatted string value is changed.
   */
  onInputChange: index.func,

  /**
   * Callback fired when the Google Maps Geocoder is queried.
   */
  onGeocode: index.func,

  /**
   * Callback fired when the geocoder has returned location results.
   */
  onGeocoderSuccess: index.func,

  /**
   * Callback fired when the geocoder throws an error.
   */
  onGeocoderError: index.func,

  /**
   * A map of Google Maps address component names to the [nameType, name].
   * NameType = short_name | long_name
   * name = the name of the componeny key in the parsed results.
   */
  componentsMap: index.object,

  /**
  * Callback fired when the Google Maps Geocoder has completed.
  */
  onGeocoderSettled: index.func
};

exports.AddressField = AddressField;
exports.default = AddressField;
